import axios from 'axios'
import qs from 'qs'

class Wishlist {
  add(product_id) {
    axios({
      method: 'post',
      headers: {'content-type': 'application/x-www-form-urlencoded'},
      url: '/index.php?route=account/wishlist/add',
      data: qs.stringify({product_id}),
    })
      .then(response => {
        //
      })
  }
}

export const wishlist = new Wishlist()
